import { format } from 'date-fns'
import { useMemo } from 'react'
import { Contract_workdays as Workday } from '../../../typings/Contract'

interface Props {
  startsAt: Workday['startsAt']
}

export const StartTime = ({ startsAt }: Props) => {
  const startsTime = useMemo(() => {
    return format(new Date(startsAt), 'HH:mm')
  }, [startsAt])

  return <>{startsTime}</>
}
